// API Configuration - Update BASE_URL for production deployment
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
  const url = `${BASE_URL}${endpoint}`;
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  
  const response = await fetch(url, { ...defaultOptions, ...options });
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`);
  }
  
  return response;
};

// Quiz API
const getQuiz = async ({ id, isLast }) => {
  return apiCall('/api/quiz', {
    method: 'POST',
    body: JSON.stringify({ id, isLast })
  });
};

// Analyze quiz results with AI
const analyzeQuizResults = async (answerPath, finalAnswerId) => {
  return apiCall('/api/quiz/analyze', {
    method: 'POST',
    body: JSON.stringify({ answerPath, finalAnswerId })
  });
};

// Get all vacancies
const getVacancy = async () => {
  return apiCall('/api/vacancies', {
    method: 'GET'
  });
};

// Get vacancy recommendations based on role
const getRecommendation = async (role) => {
  return apiCall('/api/vacancies/recommend', {
    method: 'POST',
    body: JSON.stringify({ RecommendationRole: role })
  });
};

// Get featured vacancies for landing page
const getNewVacancy = async () => {
  return apiCall('/api/vacancies/featured', {
    method: 'GET'
  });
};

// Get AI career advice
const getCareerAdvice = async (question, context = {}) => {
  return apiCall('/api/career/advice', {
    method: 'POST',
    body: JSON.stringify({ question, context })
  });
};

// Get skill recommendations
const getSkillRecommendations = async (targetRole) => {
  return apiCall('/api/career/skills', {
    method: 'POST',
    body: JSON.stringify({ targetRole })
  });
};

// Get all career paths
const getCareerPaths = async () => {
  return apiCall('/api/career/paths', {
    method: 'GET'
  });
};

export {
  getQuiz,
  getVacancy,
  getNewVacancy,
  getRecommendation,
  analyzeQuizResults,
  getCareerAdvice,
  getSkillRecommendations,
  getCareerPaths
};
